import React, { useEffect, useRef } from 'react';
import Philipp from '../assets/partner/Philip.png';
import GermanyFlag from '../assets/partner/germany-flag.png';
import { useNavigate } from 'react-router-dom';
import { logo, logo_home, cart, user } from '../Data/Images/Home';

const PractitionersWebinar = () => {
  const webinarContainerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const script = document.createElement('script');

    script.src =
      'https://event.webinarjam.com/register/o1z17otm/embed-form?formButtonText=Register&formAccentColor=%2329b6f6&formAccentOpacity=0.95&formBgColor=%23ffffff&formBgOpacity=1&buttonBgColor=%005d67';
    script.async = true;

    if (webinarContainerRef.current) {
      webinarContainerRef.current.appendChild(script);
    }

    const handleSuccess = () => {
      navigate('/practitioners/webinar-ty');
    };

    window.addEventListener('wj:registration-success', handleSuccess);

    return () => {
      window.removeEventListener('wj:registration-success', handleSuccess);
      if (webinarContainerRef.current && webinarContainerRef.current.contains(script)) {
        webinarContainerRef.current.removeChild(script);
      }
    };
  }, []);

  return (
    <>
      <div className="sticky-top t-bg-secondary t-py-2">
        <div className="container">
          <img src={logo} alt="logo riise" width={60} />
        </div>
      </div>
      <div
        className="t-flex t-flex-col t-items-center t-justify-center t-gap-4 t-p-6"
        style={{ fontFamily: 'Roboto' }}
      >
        <div className="t-w-full t-max-w-[500px] t-mx-auto t-flex t-flex-col t-items-center t-justify-center t-gap-2">
          <p className="!t-m-0 t-text-lg t-text-center">Line Webinar</p>
          <h1 className="!t-m-0 t-text-center t-font-extrabold">
            Personalisierte Mikronährstofftherapie leicht gemacht
          </h1>
          <h4 className="!t-m-0 !t-w-[80%] t-text-center t-text-secondary">
            Donnerstag, 18. Dezember 2025, 12:30 Uhr
          </h4>
        </div>
        <div className="t-w-full t-max-w-[340px] t-mx-auto t-flex t-items-start t-bg-secondary t-text-white t-rounded-lg t-p-4 t-gap-4">
          <img src={Philipp} alt="" className="t-w-[120px] t-h-[120px] t-rounded-xl" />
          <div className="t-flex t-flex-col t-gap-1">
            <p className="!t-m-0 t-text-lg">mit</p>
            <h4 className="!t-m-0 t-font-extrabold">Philipp Pfeiffer</h4>
            <h6 className="!t-m-0">Zertifizierter Ernährungsberater, Funktionelle Medizin</h6>
          </div>
        </div>
        <div className="t-w-full t-max-w-[500px] t-mx-auto t-flex t-flex-col t-items-start t-gap-2">
          <h4 className="!t-m-0 t-font-extrabold">Im Webinar erfährst du:</h4>
          <ul className="t-list-disc t-text-base">
            <li>Wie personalisierte Mikronährstofftherapie funktioniert — Schritt für Schritt</li>
            <li>Wie du vollständig individuelle Rezepturen in nur wenigen Minuten erstellst</li>
            <li>Wie du deine Praxis professionalisieren und gleichzeitig Zeit sparen kannst</li>
            <li>Praxisbeispiele für verschiedene Kund:innen und Zielgruppen</li>
            <li>
              Bonus: Ein Einblick in die neue Riise Plattform, mit der du personalisierte Formeln für deine
              Klient:innen erstellen kannst
            </li>
          </ul>
        </div>
        <div className="t-flex t-items-center t-gap-2">
          <p className="!t-m-0 t-text-lg t-font-bold">Sprache: </p>
          <img src={GermanyFlag} alt="" className="t-h-6 t-w-6 md:t-w-8 md:t-h-8" />
        </div>
        <div className="t-w-full t-max-w-[500px] t-mx-auto t-flex t-flex-col t-items-start t-gap-2">
          <h4 className="!t-m-0 t-font-extrabold">Kostenlos anmelden:</h4>
          <div
            className="wj-embed-wrapper w-full flex justify-center"
            data-webinar-hash="o1z17otm"
            ref={webinarContainerRef}
          ></div>
        </div>
      </div>
    </>
  );
};

export default PractitionersWebinar;
